import React from 'react'

interface CategoryTabsProps {
  categories: string[]
  selectedCategory: string | null
  onCategorySelect: (categoryId: string | number | null) => void
  isLoading?: boolean
}

const CategoryTabs: React.FC<CategoryTabsProps> = ({
  categories,
  selectedCategory,
  onCategorySelect,
  isLoading = false
}) => {
  // عند التحميل، إظهار placeholder مشابه للكروت
  if (isLoading) {
    return (
      <div className=" flex items-center justify-start gap-4 pt-3 overflow-x-auto px-4 mb-4">
        {Array.from({ length: 10 }).map((_, idx) => (
          <div
            key={idx}
            className="bg-white rounded-2xl p-1 animate-pulse shrink-0"
            style={{ width: '100px', height: '55px' }}
          >
            <div className="w-full h-10 bg-gray-100 rounded-xl mb-0" />
           
          </div>
        ))}
      </div>
    )
  }

  // عند عدم وجود بيانات، لا نعرض أي شيء (لا fallback categories)
  if (!categories || categories.length === 0) {
    return null
  }

  return (
    <div className="h-20 flex items-center justify-start gap-3 overflow-x-auto px-4 mb-4">
      {categories.map((cat, idx) => (
        <button
          key={idx}
          onClick={() => onCategorySelect(cat)}
          className={`category-tab-button h-12 rounded-2xl px-4 flex items-center justify-center whitespace-nowrap ${
            selectedCategory === cat ? 'bg-flutter-button text-white' : 'bg-white text-[#525866]'
          }`}
        >
          <span className="text-sm font-semibold">{cat}</span>
        </button>
      ))}
    </div>
  )
}

export default CategoryTabs

